import { Switch } from '@platform/ui-library';
import { SwitchProps } from '@platform/ui-library/build/Switch/types';
import { ChangeEvent, useState } from 'react';
import style from './switch-wrapper.module.scss';

type SwitchWrapperProps = SwitchProps & {
  tooltip?: string;
};

export function SwitchWrapper({ defaultChecked, tooltip, ...props }: SwitchWrapperProps) {
  const [enabled, setEnabled] = useState(defaultChecked);

  const onChange = (e: ChangeEvent<HTMLInputElement>) => {
    const { checked } = e.target;
    setEnabled(checked as any);
    props?.onChange?.(e);
  };

  return (
    <div className={style.container}>
      <Switch {...props} checked={enabled} onChange={onChange} />
      {tooltip && (
        <span data-tip={tooltip}>
          <i className="fe icon-info" />
        </span>
      )}
    </div>
  );
}
